/* Northwoofs cart drawer. Renders from /cart.js, updates with the Cart AJAX API.
   Opens from the header cart button and after any add-to-cart (Horizon's shopify:cart:lines-update event). */
(function () {
  /* Shopify's language root (/de/ on German pages): cart and product data then come back in the shop language */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const root = document.querySelector('[data-nw-cart]');
  if (!root) return;
  const scrim = document.querySelector('[data-nw-cart-scrim]');
  const body = root.querySelector('[data-nw-cart-body]');
  const foot = root.querySelector('[data-nw-cart-foot]');
  const titleEl = root.querySelector('[data-nw-cart-title]');
  const FREE = parseInt(root.dataset.free, 10) || 15000;
  const DAYS = parseInt(root.dataset.days, 10) || 14;            // ID tags, tumblers: working days
  const GEAR_TYPES = (root.dataset.gearTypes || '').split(',').map(s => s.trim()).filter(Boolean);
  const GEAR_MIN = parseInt(root.dataset.gearMin, 10) || 15;     // biothane gear: 3-6 weeks
  const GEAR_MAX = parseInt(root.dataset.gearMax, 10) || 30;
  const MONEY = root.dataset.money || '€{{amount_with_comma_separator}}';
  const upsell = JSON.parse(root.querySelector('[data-nw-cart-upsell]').textContent || '[]');
  const tagPool = JSON.parse((root.querySelector('[data-nw-cart-tagpool]') || {}).textContent || '[]').filter(Boolean);
  const pay = JSON.parse(root.querySelector('[data-nw-cart-pay]').textContent || '[]');
  const payCount = parseInt(root.querySelector('[data-nw-cart-paycount]').textContent, 10) || 0;
  const open = {};
  let noteOpen = null, noteDraft = null;   // order note: open or not, and what's typed, kept across re-renders
  let cart = null;
  const TX = window.NWT.cart, tx = window.NWT.fmt;   // the drawer's words, from the language files (snippets/nw-t)

  const ICON = {
    chev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>',
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg>',
    o: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>',
    h: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M14 4 20 10 10 20 4 14Z"/><path d="m8 16 -4 4"/></svg>',
    t: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M1 4h14v12H1zM15 9h4l3 3v4h-7"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>',
    d: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 11 12 3l9 8v10H3Z"/><path d="M9 21v-6h6v6"/></svg>'
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }
  function money(cents) {
    const n = (cents / 100);
    const fmt = (dec, th, ds) => { const p = n.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(ds); };
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: fmt(2, ',', '.'), amount_no_decimals: fmt(0, ',', '.'),
      amount_with_comma_separator: fmt(2, '.', ','), amount_no_decimals_with_comma_separator: fmt(0, '.', ','),
      amount_with_space_separator: fmt(2, ' ', ','), amount_with_apostrophe_separator: fmt(2, "'", '.')
    }[k] || fmt(2, '.', ',')));
  }
  function addWorkdays(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; }
  function fmtDate(d) { return d.toLocaleDateString(TX.date_locale, { day: 'numeric', month: 'short' }); }
  // engraving details: skip hidden (_) keys, empty values and links (e.g. the personalizer's preview image)
  function props(item) { return Object.entries(item.properties || {}).map(([k, v]) => [String(k).trim(), v]).filter(([k, v]) => k.charAt(0) !== '_' && v !== '' && v != null && typeof v !== 'object' && !/^https?:\/\//.test(String(v))); }
  // the personalizer's rendered design, if there is one
  function previewImg(item) { return picOf(item.properties || {}); }
  /* a line's own picture: an uploaded file or tag-look's drawing. Not the collar's Preview, a page (/p/) that draws it */
  function picOf(pr) { const v = pr.Preview || pr._Preview || pr['_Preview Front'] || pr._design_Preview || ''; return /^https?:\/\//.test(v) && !/^https:\/\/(nw-collar\.[^/]+|collar\.northwoofs\.com)\/p\//.test(v) ? v : ''; }
  /* collars and leashes: the server's drawing of the design (nw-collar /p/<design>.png, the builder's own recolouring),
     a plain picture: nothing is uploaded with them and the cart needs no builder code */
  /* the new address, and the old workers.dev one that carts and orders from before still carry */
  const COLLAR = 'https://collar.northwoofs.com', COLLAR_OLD = 'https://nw-collar.weathered-sea-bb20.workers.dev', collarPics = {};
  function collarPic(item) {
    const p = item.properties || {}, k = p._collar; if (!k) return '';
    if (collarPics[k]) return collarPics[k];
    const v = typeof p._Preview === 'string' && (p._Preview.indexOf(COLLAR + '/p/') === 0 || p._Preview.indexOf(COLLAR_OLD + '/p/') === 0) ? p._Preview : COLLAR + '/p/' + btoa(unescape(encodeURIComponent(k))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return collarPics[k] = v + '.png?w=400&bg=none';
  }
  // our collar builder stores the design in _collar: link back to the builder with it, to change it in place
  const b64u = str => btoa(unescape(encodeURIComponent(str))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  function editLink(item) {
    const raw = (item.properties || {})._collar;
    if (raw) {
      try {
        const d = JSON.parse(raw);
        const u = item.url + (item.url.indexOf('?') < 0 ? '?' : '&') + 'collar=' + b64u(JSON.stringify({ s: d.s, e: item.key, q: item.quantity }));
        return '<a class="nw-lnk" href="' + esc(u) + '" data-collar-edit="' + esc(item.key) + '">' + TX.edit_design + '</a>';
      } catch (e) {}
    }
    // a tag from our personalizer: reopen it with this line's design, and its Add to cart replaces the line
    const p = item.properties || {};
    if (p['_Preview Front'] || p.Back) return '<a class="nw-lnk" href="' + esc(item.url + (item.url.indexOf('?') < 0 ? '?' : '&') + 'nwedit=' + encodeURIComponent(item.key)) + '" data-tag-edit="' + esc(item.key) + '">' + TX.edit_design + '</a>';
    return '<a class="nw-lnk" href="' + esc(item.url) + '">' + TX.edit_design + '</a>';
  }
  function shortName(t) { return String(t).split(' - ')[0]; }
  const isColourKey = k => /^(colou?r|farbe)$/i.test(String(k).trim());

  // discount codes applied to the whole order (e.g. the 10% welcome code from the sign-up popup)
  const TAG_I = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12V4h8l10 10-8 8Z"/><circle cx="7.5" cy="8.5" r="1.3"/></svg>';
  function codeApps() { return (cart.cart_level_discount_applications || []).filter(a => a.type === 'discount_code' && a.total_allocated_amount > 0); }
  function codeLabel(code) { return /^(NW10-|NWHELLO)/i.test(code) ? TX.welcome_code : TX.discount_code; }
  /* fitting room chip (assets/nw-wardrobe.js): only when the cart has a collar; one circle per kind, with a count */
  /* the try-on lives as a small 'Try on' pill in the cart header; it shows when the cart has anything to try on
     (a tag or a leash alone too: it hangs on the grey stand-in collar) */
  function fitOk() {
    const W = window.NWWardrobe; if (!W || !cart) return false;
    /* only pieces the fitting room can draw: collars and leashes made in the builder, tags with a picture */
    return cart.items.some(it => { const k = W.kindOfType(it.product_type, it.properties), p = it.properties || {};
      return k === 'tag' ? !!(p['_Preview Front'] || p._Preview) : !!(k && p._collar); });
  }
  function fitChip() {
    const W = window.NWWardrobe; if (!W || !cart) return '';
    const cnt = { collar: 0, tag: 0, leash: 0 }, img = {};
    cart.items.forEach(it => { const k = W.kindOfType(it.product_type, it.properties); if (!k) return; cnt[k] += it.quantity; if (!img[k]) { const p = it.properties || {}; img[k] = flatLook(picOf(p)) || collarPics[p._collar] || it.image; } });
    if (!cnt.collar && !cnt.tag && !cnt.leash) return '';
    const c = ['collar', 'tag', 'leash'].filter(k => cnt[k]).map(k => '<i><img alt="" src="' + esc(img[k] || '') + '">' + (cnt[k] > 1 ? '<em>' + cnt[k] + '</em>' : '') + '</i>').join('');
    return '<div class="nw-cart__sec"><button type="button" class="nw-fitchip" data-fit-chip><span class="nw-fitchip__c">' + c + '</span><b>' + TX.see_set + '</b>' + ICON.arrow + '</button></div>';
  }
  function fsb() {
    const t = cart.total_price, left = FREE - t, pct = Math.min(100, t / FREE * 100);
    // codes working on this cart, plus the welcome code while the cart is still empty (it waits there until checkout);
    // but not a welcome code Shopify turns down for the items in the cart (e.g. used before): it would look active at
    // full price. (In an empty cart Shopify marks every code "not applicable", so there it can't be told apart.)
    const names = codeApps().map(a => a.title);
    if (!names.length) { const w = (cart.discount_codes || []).filter(d => (!cart.item_count || d.applicable !== false) && /^(NW10-|NWHELLO)/i.test(d.code)).pop(); if (w) names.push(w.code); }
    const codes = names.map(c => '<div class="nw-fsb__code"><span>' + TAG_I + esc(codeLabel(c)) + '</span><span class="nw-fsb__cr"><code>' + esc(c) +
      '</code><button type="button" class="nw-fsb__x" data-rmcode="' + esc(c) + '" aria-label="' + esc(tx(TX.remove_code, { code: c })) + '">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></span></div>').join('');
    return '<div class="nw-fsb' + (left <= 0 ? ' done' : '') + '"><p>' +
      (left > 0 ? tx(TX.away, { amount: money(left) }) : '<b>' + TX.unlocked + '</b>') +
      '</p><div class="nw-fsb__bar"><i style="width:' + pct + '%"></i></div>' + codes + '</div>';
  }
  // line price: old price crossed out + new price when a discount (line or order level) lowers it
  // compare-at prices aren't in /cart.js: read them from each product's .js once
  const CMP = {};   // variant id -> compare_at_price (cents)
  async function loadCompare() {
    const need = [...new Set((cart.items || []).filter(i => !(i.variant_id in CMP)).map(i => i.handle))];
    await Promise.all(need.map(h => fetch(ROOT + 'products/' + h + '.js').then(r => r.ok ? r.json() : null).then(p => {
      (p && p.variants || []).forEach(v => { CMP[v.id] = v.compare_at_price || 0; });
    }).catch(() => {})));
    (cart.items || []).forEach(i => { if (!(i.variant_id in CMP)) CMP[i.variant_id] = 0; });
  }
  function salePrice(price, compare) { return compare > price ? '<span class="nw-sale"><span class="nw-now">' + money(price) + '</span><s class="nw-was">' + money(compare) + '</s></span>' : money(price); }
  function linePrice(item) {
    const cmp = (CMP[item.variant_id] || 0) * item.quantity;
    const before = Math.max(item.original_line_price, cmp), after = item.final_line_price - Math.max(0, (item.total_discount || 0) - (item.line_level_total_discount || 0));
    return after < before ? '<s class="nw-was">' + money(before) + '</s><em class="nw-now">' + money(after) + '</em>' : money(item.final_line_price);
  }

  const LOOK = 'https://look.northwoofs.com', LOOK_OLD = 'https://nw-tag-look.weathered-sea-bb20.workers.dev';   /* the old address: carts from before still carry it */
  const isLookImg = v => v.indexOf(LOOK + '/img/') === 0 || v.indexOf(LOOK_OLD + '/img/') === 0;
  const slugC = v => String(v).toLowerCase().normalize('NFKD').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  /* a personalised tag: the same fanned picture, with the customer's own front and back (the personalizer's previews)
     in place of the drawn ones. It links to those pictures, so it goes into the page inline; fetched once per design. */
  const ownPics = {};
  /* tag-look's own drawing of this line (the personalizer sends its address in _Preview): an ordinary picture */
  function lookPic(item) { const p = item.properties || {}, v = p.Preview || p._Preview; return typeof v === 'string' && isLookImg(v) ? v : ''; }
  /* shown as a flat, see-through PNG made by tag-look, never as the layered drawing (SVG): on an iPhone short of
     memory Safari could draw only the drawing's dark bottom layer, a black tag. The line keeps the .svg address. */
  const flatLook = v => { if (!v || !isLookImg(v)) return v; try { const u = new URL(v); if (!/\.svg$/.test(u.pathname)) return v; u.pathname = u.pathname.replace(/\.svg$/, '.png'); u.searchParams.set('bg', 'none'); u.searchParams.set('w', '480'); return u.toString(); } catch (e) { return v; } };
  /* a tag being added (the personalizer's own request): start making its picture at once, so it is ready when the cart opens */
  const warmAdd = body => { try { let v = ''; if (typeof body === 'string') { const m = body.match(/"_Preview"\s*:\s*"([^"]+)"/); v = m ? JSON.parse('"' + m[1] + '"') : ''; } else if (body && typeof body.get === 'function') v = body.get('properties[_Preview]') || ''; if (v && isLookImg(v)) new Image().src = flatLook(v); } catch (e) {} };
  function ownKey(item) {
    return '';   /* see flatLook: no layered drawings in the cart; picFor shows the uploaded front instead */
    if (lookPic(item)) return '';
    const p = item.properties || {}, f = p['_Preview Front'], b = p['_Preview Back'];
    if (!/^https:\/\/cdn\.shopify\.com\//.test(f || '')) return '';
    const small = v => v + (v.indexOf('?') < 0 ? '?' : '&') + 'width=320';
    return LOOK + '/img/' + item.handle + '/' + tagColour(item) + '.svg?bg=none&live=0&pf=' + encodeURIComponent(small(f)) + (/^https:\/\/cdn\.shopify\.com\//.test(b || '') ? '&pb=' + encodeURIComponent(small(b)) : '');
  }
  function fetchOwn(k) {
    if (ownPics[k] !== undefined) return;
    ownPics[k] = null;
    fetch(k).then(r => r.ok ? r.text() : Promise.reject()).then(t => {
      ownPics[k] = t.replace(/<svg([^>]*?)\swidth="[^"]*"\sheight="[^"]*"/, '<svg$1 width="100%" height="100%"');
      root.querySelectorAll('[data-own]').forEach(el => { if (el.dataset.own === k) el.innerHTML = ownPics[k]; });
    }).catch(() => { ownPics[k] = ''; });
  }
  function tagColour(item) {
    const c = props(item).find(p => isColourKey(p[0]));
    const colour = c ? c[1] : (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '0');
    return slugC(colour) || '0';
  }
  /* NW Studio's ready-made picture of the design in that colour */
  function tagPic(item) { return LOOK + '/ri/' + item.handle + '/' + tagColour(item) + '/im.webp'; }
  function itemCard(item, i) {
    /* being replaced by an edit: the new words show at once, the picture waits for the upload */
    const pend = pending[item.key];
    if (pend) item = pendItem(item, pend);
    const pr = props(item), line = i + 1, key = item.key, o = !!open[key];
    const photo = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
    /* a dog tag shows the same drawn picture as everywhere else in the shop (front and back fanned, in its colour),
       not the customer's engraving: checkout shows the product picture too. Photo if the drawing fails. */
    const isTag = item.product_type === 'Dog Tags' && item.handle;
    const img = picFor(item, photo);
    const ck = !isTag && !previewImg(item) && (item.properties || {})._collar;
    const name = item.product_type === 'Dog Tags' && !/Tag$/.test(shortName(item.product_title)) ? tx(TX.tag_name, { name: shortName(item.product_title) }) : shortName(item.product_title);
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    /* closed: what was bought (the variant, or the colour when there is none) and, on a tag or tumbler, the dog's
       name, so tags in one cart are told apart. Open: every other choice, nothing said twice. "Back: Custom text"
       stays on the order but not here: the lines below it are the custom text. */
    const col = pr.find(p => isColourKey(p[0]));
    const first = variant || (col ? String(col[1]) : '');
    const dog = (pr.find(p => p[0] === 'Name') || [])[1] || '';
    const summary = [first, dog].filter(Boolean).join(' · ');
    const same = (a, b) => String(a).toLowerCase() === String(b).toLowerCase();
    const rest = pr.filter(p => !(isColourKey(p[0]) && same(p[1], first)) && !(p[0] === 'Name' && dog) && !(p[0] === 'Back' && p[1] === 'Custom text'));
    const qty = '<div class="nw-qty"><button type="button" data-q="' + line + '" data-to="' + (item.quantity - 1) + '" aria-label="' + TX.less + '">−</button><b>' + item.quantity +
      '</b><button type="button" data-q="' + line + '" data-to="' + (item.quantity + 1) + '" aria-label="' + TX.more + '">+</button></div>';
    const trash = '<button class="nw-trash" type="button" data-q="' + line + '" data-to="0" aria-label="' + esc(tx(TX.remove, { name: name })) + '">' + ICON.trash + '</button>';
    const ok = isTag ? ownKey(item) : '';
    if (ok) fetchOwn(ok);
    const pv = ok && ownPics[ok]
      ? '<a class="nw-item__pv nw-item__pv--own" href="' + esc(item.url) + '" aria-label="' + esc(item.product_title) + '" data-own="' + esc(ok) + '">' + ownPics[ok] + '</a>'
      : '<a class="nw-item__pv' + (ok ? ' nw-item__pv--own' : '') + '" href="' + esc(item.url) + '"' + (ok ? ' data-own="' + esc(ok) + '"' : '') + '><img src="' + esc(img) + '" alt="' + esc(item.product_title) + '"' + (ck ? ' data-collar="' + esc(ck) + '"' : '') +
        (isTag && photo ? ' onerror="this.onerror=null;this.src=\'' + esc(photo) + '\'"' : '') + '></a>';
    let head;
    if (pr.length) {
      const detail = (rest.length ? '<dl class="nw-eng">' + rest.map(p => '<dt>' + esc(p[0]) + '</dt><dd>' + esc(p[1]).replace(/\n/g, '<br>') + '</dd>').join('') + '</dl>' : '') + editLink(item);
      head = '<button type="button" class="nw-xhead" data-xc="' + esc(key) + '" aria-expanded="' + o + '"><span class="nw-xhead__nm">' + esc(name) +
        '</span><span class="nw-xhead__pr">' + linePrice(item) + '</span><span class="nw-xhead__meta">' + esc(summary) +
        '</span><span class="nw-xchev" aria-hidden="true"></span></button><div class="nw-xbody"><div>' + detail + '</div></div>';
    } else {
      head = '<div class="nw-xhead static"><span class="nw-xhead__nm">' + esc(name) + '</span><span class="nw-xhead__pr">' + linePrice(item) +
        '</span>' + (variant ? '<span class="nw-xhead__meta">' + esc(variant) + '</span>' : '') + '</div>';
    }
    const note = lineNote[line] ? '<p class="nw-item__note" role="alert">' + esc(lineNote[line]) + '</p>' : '';
    const up = pend ? '<p class="nw-item__upd wait"><span><i class="nw-spin"></i>' + TX.updating + '</span></p>'
      : failed[key] ? '<p class="nw-item__note" role="alert">' + esc(failed[key]) + '</p>'
      : updated[key] ? '<p class="nw-item__upd"><span>' + ICON.check + TX.updated + '</span><button type="button" data-undo="' + esc(key) + '">' + TX.undo + '</button></p>' : '';
    return '<div class="nw-item' + (o ? ' open' : '') + (pend ? ' nw-item--pend' : '') + '">' + pv + '<div class="nw-item__b">' + head + '<div class="nw-item__row">' + qty + trash + '</div>' + note + up + '</div></div>';
  }

  // "Complete the set": Shopify complementary products (set per product in Search & Discovery),
  // topped up from the manual "complete-the-set" collection.
  const HIDE_TYPES = ['PPLR_HIDDEN_PRODUCT'];
  const recCache = {};          // product_id -> normalised list
  const added = {};             // product ids added from this row (keep them visible with "Added")
  let recList = [];
  function norm(p) {
    const parts = p.title.split(' - ');
    let t = parts[0];
    if (p.type === 'Dog Tags') t = tx(TX.tag_name, { name: t });
    const v = (p.variants || []).find(x => x.available) || (p.variants || [])[0] || {};
    let img = p.featured_image || '';
    if (img && typeof img === 'object') img = img.src || img.url || '';
    if (img.indexOf('//') === 0) img = 'https:' + img;
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
    const tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(', ');
    return { pid: p.id, id: v.id, title: t, url: p.url || '/products/' + p.handle, img: img, price: v.price != null ? v.price : p.price, compare: v.compare_at_price != null ? v.compare_at_price : (p.compare_at_price || 0),
             personalize: tags.indexOf('customize') > -1, available: p.available !== false, type: p.type };
  }
  async function recsFor(pid) {
    if (recCache[pid]) return recCache[pid];
    try {
      const r = await fetch(ROOT + 'recommendations/products.json?product_id=' + pid + '&intent=complementary&limit=6');
      const j = r.ok ? await r.json() : { products: [] };
      recCache[pid] = (j.products || []).map(norm).filter(x => x.id && x.available && HIDE_TYPES.indexOf(x.type) < 0);
    } catch (e) { recCache[pid] = []; }
    return recCache[pid];
  }
  async function buildRecs() {
    const pids = [];
    cart.items.forEach(it => { if (pids.indexOf(it.product_id) < 0) pids.push(it.product_id); });
    const lists = await Promise.all(pids.slice(0, 4).map(recsFor));   // newest items first
    const seen = {}, out = [];
    for (let i = 0; out.length < 6 && lists.some(l => l[i]); i++) {  // take turns so every item gets a say
      lists.forEach(l => { const x = l[i]; if (x && !seen[x.pid] && out.length < 6) { seen[x.pid] = 1; out.push(x); } });
    }
    recList = out;
  }
  // Any ID tag in the suggestions is a stand-in: show one random tag instead (kept for the visit, never one already in the cart)
  let randTag = null;
  try { randTag = JSON.parse(sessionStorage.getItem('nw-rand-tag') || 'null'); } catch (e) {}
  function randomTag() {
    const free = tagPool.filter(t => !cart.items.some(it => it.product_id === t.pid));
    if (!free.length) return null;
    if (!randTag || !free.some(t => t.pid === randTag.pid)) {
      randTag = free[Math.floor(Math.random() * free.length)];
      try { sessionStorage.setItem('nw-rand-tag', JSON.stringify(randTag)); } catch (e) {}
    }
    return randTag;
  }
  function swapTags(arr) {
    const out = [];
    arr.forEach(p => {
      let x = p;
      if (p.type === 'Dog Tags' && !added[p.pid] && tagPool.length) x = randomTag();
      if (x && !out.some(o => o.pid === x.pid)) out.push(x);
    });
    return out;
  }
  function upsellHTML() {
    const inCartPid = pid => cart.items.some(it => it.product_id === pid);
    const inCartUrl = url => cart.items.some(it => it.url && it.url.split('?')[0] === url);
    const pick = arr => arr.filter(p => added[p.pid || p.url] || !(p.pid ? inCartPid(p.pid) : inCartUrl(p.url)));
    // your picks first, topped up from the collection so the row never looks empty
    const list = swapTags(pick(recList));
    swapTags(pick(upsell)).forEach(p => { if (list.length < 6 && !list.some(x => x.pid === p.pid)) list.push(p); });
    if (!list.length) return '';
    return '<div class="nw-ups"><h4>' + TX.complete_set + '</h4><div class="nw-ups__row">' + list.slice(0, 6).map(p => {
      const key = p.pid || p.url;
      let ctl;
      if (added[key] && (p.pid ? inCartPid(p.pid) : inCartUrl(p.url))) ctl = '<span class="nw-addpill">' + ICON.check + TX.added + '</span>';
      else if (p.personalize) ctl = '<a class="nw-add" href="' + esc(p.url) + '" aria-label="' + esc(tx(TX.personalize, { title: p.title })) + '">' + ICON.arrow + '</a>';
      else ctl = '<button class="nw-add" type="button" data-add="' + p.id + '" data-key="' + esc(key) + '" aria-label="' + esc(tx(TX.add, { title: p.title })) + '">' + ICON.plus + '</button>';
      return '<div class="nw-up"><a href="' + esc(p.url) + '"><img src="' + esc(p.img) + '" alt=""></a><b>' + esc(p.title) + '</b><div class="nw-up__rw"><span>' + salePrice(p.price, p.compare || 0) + '</span>' + ctl + '</div></div>';
    }).join('') + '</div></div>';
  }

  function timeline() {
    // the whole order ships together, so the slowest item decides
    const gear = cart.items.some(it => GEAR_TYPES.indexOf(it.product_type) > -1);
    const now = new Date();
    const madeA = addWorkdays(now, gear ? GEAR_MIN : DAYS), madeB = addWorkdays(now, gear ? GEAR_MAX : DAYS);
    const ships = gear ? fmtDate(madeA) + '-' + fmtDate(madeB) : '~' + fmtDate(madeA);
    return '<div class="nw-tl-card"><h4>' + TX.when_ships + '</h4><div class="nw-tl">' +
      '<div class="on"><i>' + ICON.o + '</i><b>' + TX.order + '</b><small>' + TX.today + '</small></div>' +
      '<div><i>' + ICON.h + '</i><b>' + TX.production + '</b><small>' + (gear ? tx(TX.weeks, { min: Math.round(GEAR_MIN / 5), max: Math.round(GEAR_MAX / 5) }) : tx(TX.working_days, { days: DAYS })) + '</small></div>' +
      '<div><i>' + ICON.t + '</i><b>' + TX.ships + '</b><small>' + ships + '</small></div></div></div>';
  }

  function render() {
    Object.keys(pending).forEach(k => { if (!cart.items.some(i => i.key === k)) delete pending[k]; });
    const n = cart.item_count;
    titleEl.innerHTML = TX.title + (n ? '<small>' + tx(n === 1 ? TX.items_one : TX.items_other, { count: n }) + '</small>' : '');
    const tryB = root.querySelector('[data-nw-cart-try]');
    if (tryB) tryB.hidden = !(n && fitOk());
    if (!n) {
      const welcome = (cart.discount_codes || []).some(d => /^(NW10-|NWHELLO)/i.test(d.code));
      body.innerHTML = (welcome ? '<div class="nw-cart__sec">' + fsb() + '</div>' : '') + root.querySelector('[data-nw-cart-empty]').innerHTML;
      foot.hidden = true; foot.innerHTML = '';
      return;
    }
    // order note: an accordion card at the end of the list, just before the payment icons
    if (noteOpen === null) noteOpen = false;
    const noteVal = noteDraft !== null ? noteDraft : (cart.note || '');
    const note = '<details class="nw-note"' + (noteOpen ? ' open' : '') + '><summary><span class="nw-note__lbl">' + noteLabel(noteVal) + '</span>' + ICON.chev + '</summary>' +
      '<div class="nw-note__box"><textarea id="nw-cart-note" aria-label="' + TX.note_aria + '" placeholder="' + TX.note_placeholder + '" enterkeyhint="done">' + esc(noteVal) + '</textarea>' +
      '<button type="button" class="nw-note__done" data-note-done aria-label="' + TX.done + '">' + ICON.check + '</button></div></details>';
    // payment icons sit at the end of the scrolling cart (not pinned), to keep the bottom bar slim
    const payRow = '<div class="nw-payrow">' + pay.join('') + (payCount > pay.length ? '<span class="nw-others">' + window.NWT.common.others + '</span>' : '') + '</div>';
    body.innerHTML =
      '<div class="nw-cart__sec">' + fsb() + '</div>' +
      '<div class="nw-cart__sec nw-items">' + cart.items.map(itemCard).join('') + '</div>' +
      '<div class="nw-cart__sec">' + upsellHTML() + '</div>' +
      '<div class="nw-cart__sec">' + timeline() + '</div>' +
      '<div class="nw-cart__sec">' + note + '</div>' +
      '<div class="nw-cart__sec nw-paysec">' + payRow + '</div>';
    foot.innerHTML = '<div class="nw-sum"><span>' + TX.subtotal + '<small class="nw-tx">' + TX.shipping_at_checkout + '</small></span><span>' + money(cart.total_price) + '</span></div>' +
      '<a class="nw-cart__btn" href="' + ROOT + 'checkout">' + TX.checkout + '&nbsp;·&nbsp;' + money(cart.total_price) + '</a>';
    foot.hidden = false;
  }

  function bubble() {
    const icon = document.querySelector('cart-icon');
    if (icon && typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count, false);
    document.dispatchEvent(new CustomEvent('nw:cart', { detail: cart }));   // the welcome-code % badge listens
  }

  async function load() { cart = await (await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })).json(); await Promise.all([buildRecs(), loadCompare()]); render(); bubble(); }
  // a quantity change that Shopify refused (stock) or that never arrived (offline): a short note under that item
  // instead of nothing happening, cleared by the next change that goes through
  const lineNote = {};
  /* a line just replaced by an edit (Done in the personalizer): "Updated · Undo" under it for a few seconds */
  const updated = {};
  /* a line an edit is replacing right now ("Updating…"), and one whose replacement failed */
  const pending = {}, failed = {};
  /* the picture a line shows (tags: tag-look; collars and leashes: their Preview or nw-collar's drawing; else the product photo) */
  function picFor(item, photo) {
    const isTag = item.product_type === 'Dog Tags' && item.handle;
    const pf = (item.properties || {})['_Preview Front'];
    return isTag ? (flatLook(lookPic(item)) || (/^https:\/\/cdn\.shopify\.com\//.test(pf || '') ? pf : '') || tagPic(item)) : (previewImg(item) || collarPic(item) || photo || '');
  }
  /* a line being replaced by an edit: the new words at once; the picture stays the current one until the new one has
     loaded (it is drawn on the server and may take a moment), so it never goes blank */
  function pendItem(item, pend) {
    const keep = {}, cur = item.properties || {}, np = pend.props || {};
    Object.keys(cur).forEach(k => { if (k.charAt(0) === '_' || /^Preview/.test(k)) keep[k] = cur[k]; });
    const vis = {}; Object.keys(np).forEach(k => { if (pend.ready || !(k.charAt(0) === '_' || /^Preview/.test(k))) vis[k] = np[k]; });
    return Object.assign({}, item, { properties: Object.assign(keep, vis) });
  }
  function markPending(key, props) {
    pending[key] = { props: props || {}, ready: false };
    const line = cart && cart.items.find(i => i.key === key);
    if (line) {
      const u = picFor(pendItem(line, { props: props || {}, ready: true }), '');
      if (u && u !== picFor(line, '')) { const im = new Image(); im.onload = im.onerror = () => { if (pending[key]) { pending[key].ready = true; render(); } }; im.src = u; }
      else pending[key].ready = true;
    }
    setTimeout(() => { if (pending[key]) { delete pending[key]; if (cart) render(); } }, 30000);
    if (cart) render();
  }
  function failPending(key) {
    delete pending[key]; failed[key] = TX.save_failed;
    setTimeout(() => { delete failed[key]; if (cart) render(); }, 6000);
    if (cart) render();
  }
  /* nw:line-replaced {from, to}: an edit made here swapped one line for another (the fitting room follows it) */
  const replaced = (from, to, was) => { if (from && to && from !== to) document.dispatchEvent(new CustomEvent('nw:line-replaced', { detail: { from, to, was: was || null } })); };   // was: {variant_id, properties} of the old line
  function markUpdated(key, old, from) {
    updated[key] = { old }; replaced(from, key, old ? { variant_id: old.id, properties: old.properties || {} } : null);
    setTimeout(() => { if (updated[key]) { delete updated[key]; if (cart) render(); } }, 8000);
  }
  function whyNot(desc) {
    if (navigator.onLine === false || !desc) return navigator.onLine === false ? TX.offline : TX.update_failed;
    const n = String(desc).match(/(\d+)/);
    return /only|can.t add|cannot add|are in your cart|sold out/i.test(desc) ? (n ? tx(TX.only_in_stock, { count: n[1] }) : TX.no_more_stock) : TX.update_failed;
  }
  /* url without the leading slash ("cart/change.js"): sent to the language root, so the cart comes back in the page's language */
  async function post(url, data) {
    root.classList.add('busy');
    try {
      selfAdd = true;
      let r = null;
      try { r = await fetch(ROOT + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) }); }
      catch (e) { r = null; }
      selfAdd = false;
      if (!r || !r.ok) {
        const j = r ? await r.json().catch(() => ({})) : {};
        if (data && data.line) { lineNote[data.line] = whyNot(j.description || j.message); render(); }
        else if (window.console) console.warn('cart update failed', j);
        return;
      }
      for (const k in lineNote) delete lineNote[k];
      if (url === 'cart/add.js') await load(); else { cart = await r.json(); await Promise.all([buildRecs(), loadCompare()]); render(); bubble(); }
    } finally { root.classList.remove('busy'); }
  }

  function openCart() {
    root.dispatchEvent(new Event('nw:cart-open'));
    root.classList.add('open'); scrim.hidden = false; requestAnimationFrame(() => scrim.classList.add('open'));
    root.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('nw-cart-lock');
    load();
  }
  function closeCart() {
    if (root.contains(document.activeElement)) document.activeElement.blur();   // drops the phone keyboard
    root.classList.remove('open'); scrim.classList.remove('open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('nw-cart-lock'); setTimeout(() => { if (!root.classList.contains('open')) scrim.hidden = true; }, 300);
  }
  window.NWCart = { open: openCart, close: closeCart, refresh: load, markUpdated: markUpdated, markPending: markPending, failPending: failPending };
  /* Undo: the new line out, the old one back exactly as it was */
  root.addEventListener('click', e => {
    const u = e.target.closest('[data-undo]'); if (!u) return;
    const k = u.dataset.undo, x = updated[k]; if (!x) return;
    delete updated[k]; u.disabled = true; const cur = cart && cart.items.find(i => i.key === k);
    const J = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-NW-Quiet': '1' };
    fetch(ROOT + 'cart/change.js', { method: 'POST', headers: J, body: JSON.stringify({ id: k, quantity: 0 }) })
      .then(() => fetch(ROOT + 'cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: [x.old] }) }))
      .then(r => r.json()).then(j => { const nk = j && j.items && j.items[0] && j.items[0].key; replaced(k, nk, cur ? { variant_id: cur.variant_id, properties: cur.properties || {} } : null); })
      .catch(() => {}).then(() => load());
  });
  // why an add to cart was refused, in plain words (product pages use it for their message box)
  window.NWCartWhy = function (desc) {
    const d = String(desc || '');
    if (navigator.onLine === false) return { title: TX.offline_title, body: TX.offline_body };
    if (/sold out/i.test(d)) return { title: TX.sold_out_title, body: TX.sold_out_body };
    const n = d.match(/(\d+)/);
    if (/are in your cart|can.t add more|cannot add more|only/i.test(d)) return { title: n ? tx(TX.last_n, { count: n[1] }) : TX.last_ones, body: TX.cant_add_more };
    return { title: TX.add_failed, body: TX.please_try_again };
  };

  // header: slides up with the list as you scroll down and comes back as you scroll up, following the scroll
  // pixel by pixel (no layout change, so nothing jumps). Let go halfway and it glides to shown or hidden.
  (function () {
    const top = root.querySelector('.nw-cart__top');
    let last = 0, off = 0, idle = null;
    const set = v => { off = v; top.style.setProperty('--nw-hdr', String(v)); root.classList.toggle('mini', v > 36); };
    body.addEventListener('scroll', () => {
      const H = top.offsetHeight || 72, y = Math.max(0, body.scrollTop);
      top.classList.remove('snap');
      set(y <= 0 ? 0 : Math.min(H, Math.max(0, off + (y - last))));
      last = y;
      clearTimeout(idle);
      idle = setTimeout(() => {
        if (off > 0 && off < H) { top.classList.add('snap'); set(off > H / 2 && body.scrollTop > H ? H : 0); }
      }, 140);
    }, { passive: true });
    root.addEventListener('nw:cart-open', () => { last = 0; top.classList.remove('snap'); set(0); });
  })();

  // swipe left or right to close (the drawer slides back out to the right as the finger moves, like the phone menu).
  // Swipes that start on the sideways "Complete the set" row or in a text field scroll / edit as usual.
  (function () {
    let sx = 0, sy = 0, st = 0, dx = 0, mode = null;
    root.addEventListener('touchstart', e => {
      mode = null;
      if (!root.classList.contains('open') || e.touches.length !== 1) return;
      if (e.target.closest('.nw-ups__row, input, textarea, select')) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now(); dx = 0; mode = 'wait';
    }, { passive: true });
    root.addEventListener('touchmove', e => {
      if (!mode || mode === 'v') return;
      const x = e.touches[0].clientX - sx, y = e.touches[0].clientY - sy;
      if (mode === 'wait') {
        if (Math.abs(x) < 8 && Math.abs(y) < 8) return;
        mode = Math.abs(x) > Math.abs(y) * 1.2 ? 'h' : 'v';
        if (mode === 'v') return;
        root.style.transition = 'none'; scrim.style.transition = 'none';
      }
      if (e.cancelable) e.preventDefault();
      dx = Math.abs(x);
      root.style.transform = 'translateX(' + dx + 'px)';
      scrim.style.opacity = String(Math.max(0, 1 - dx / (root.offsetWidth || 1)));
    }, { passive: false });
    const end = () => {
      if (mode !== 'h') { mode = null; return; }
      mode = null;
      const w = root.offsetWidth || 1, v = dx / Math.max(1, Date.now() - st);
      root.style.transition = ''; scrim.style.transition = '';
      root.style.transform = ''; scrim.style.opacity = '';          // same frame as the close, so it slides on from the finger
      if (dx > w * 0.3 || v > 0.5) closeCart();
    };
    root.addEventListener('touchend', end, { passive: true });
    root.addEventListener('touchcancel', end, { passive: true });
  })();

  // apps like the personalizer add to cart on their own: open the drawer when any /cart/add request succeeds
  let selfAdd = false;
  const isAdd = u => /\/cart\/add(\.js(on)?)?(\?|$)/.test(String(u || ''));
  // (the personalizer reloads the page right after adding, so the add is remembered for a few seconds)
  const afterAdd = () => { if (selfAdd) return; try { sessionStorage.setItem('nw-open-cart', String(Date.now())); } catch (e) {} setTimeout(openCart, 50); };
  try {
    const t = +sessionStorage.getItem('nw-open-cart');
    if (t) { sessionStorage.removeItem('nw-open-cart'); if (Date.now() - t < 15000) setTimeout(openCart, 150); }
  } catch (e) {}
  document.addEventListener('click', () => { try { sessionStorage.removeItem('nw-open-cart'); } catch (e) {} }, true);
  const _fetch = window.fetch;
  /* every change to the cart from this page goes to Shopify one after another: two changes sent at the same moment can
     both come back OK while Shopify keeps only one of them (a tag and a leash added together: only the leash stayed) */
  const isWrite = u => /\/cart\/(add|change|update|clear)(\.js(on)?)?(\?|$)/.test(String(u || ''));
  let cartQ = Promise.resolve();
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url);
    const method = String((init && init.method) || (input && typeof input !== 'string' && input.method) || 'GET').toUpperCase();
    const self = this, args = arguments, go = () => _fetch.apply(self, args);
    let pr;
    /* (a change that never answers holds the next one back for 20 s at most) */
    if (method === 'POST' && isWrite(url)) { pr = cartQ.then(go, go); cartQ = Promise.race([pr.catch(() => {}), new Promise(r => setTimeout(r, 20000))]); }
    else pr = go();
    const hd = init && init.headers, quiet = hd && (typeof hd.get === 'function' ? hd.get('X-NW-Quiet') : hd['X-NW-Quiet']);
    if (isAdd(url)) warmAdd(init && init.body);
    if (isAdd(url) && !quiet) pr.then(r => { if (r.ok) afterAdd(); }).catch(() => {});
    return pr;
  };
  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) { this._nwAdd = isAdd(u); return _open.apply(this, arguments); };
  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (b) { if (this._nwAdd) warmAdd(b); if (this._nwAdd) this.addEventListener('load', () => { if (this.status >= 200 && this.status < 300) afterAdd(); }); return _send.apply(this, arguments); };

  // header cart button (Horizon's drawer trigger) -> our drawer
  window.addEventListener('click', e => {
    const t = e.target.closest('[data-testid="cart-drawer-trigger"], .header-actions__action.action__cart, [data-nw-cart-open]');
    if (!t) return;
    e.preventDefault(); e.stopImmediatePropagation();
    // cart icon inside the phone menu: close the menu first, then slide in the cart
    const menu = t.closest('[data-nw-drawer]');
    if (menu) {
      const x = menu.querySelector('.nw-dr__top button.nw-dr__ib');
      if (x) x.click(); else { const d = menu.closest('details'); if (d) d.removeAttribute('open'); }
      setTimeout(openCart, 120);
    } else openCart();
  }, true);
  // after any add to cart from the theme
  document.addEventListener('shopify:cart:lines-update', e => {
    const p = e.promise || Promise.resolve();
    p.then(() => { openCart(); }).catch(() => {});
  });
  scrim.addEventListener('click', closeCart);
  root.addEventListener('click', e => { if (e.target.closest('[data-fit-chip]') && window.NWWardrobe) window.NWWardrobe.tryCart(); });
  /* Edit design on a collar or leash: the builder opens right here above the cart (the link stays as the fallback) */
  root.addEventListener('click', e => { const a = e.target.closest('[data-tag-edit]'); if (!a || !cart || !window.NWWardrobe || !window.NWWardrobe.editTagLine) return; const it = cart.items.find(x => x.key === a.dataset.tagEdit); if (it && window.NWWardrobe.editTagLine(it)) { e.preventDefault(); flyEdit(a, it); } });
  /* Edit design on a phone (7 Oct): the front tag lifts out of the line's own picture (its name, colour and portrait
     already on it) and the personalizer is built around it (nw-tag-picker.js, NWFly), so the real one takes over
     with nothing changing on screen. Only for lines drawn by tag-look (_Preview); the rest open as before. */
  const frontOf = it => { const v = lookPic(it); if (!v) return ''; try { const u = new URL(v), q = new URLSearchParams(); ['n', 'pid', 'd'].forEach(k => { if (u.searchParams.get(k) != null) q.set(k, u.searchParams.get(k)); }); q.set('w', '600'); return u.origin + u.pathname.replace(/^\/img\//, '/front/').replace(/\.svg$/, '.png') + '?' + q; } catch (x) { return ''; } };
  const frIm = {};
  const warmEdit = it => { if (innerWidth >= 768 || !window.NWFly) return; const s = frontOf(it); if (!s) return; if (!frIm[s]) { const x = frIm[s] = new Image(); x.crossOrigin = 'anonymous'; x.src = s; } window.NWFly.design(it.handle); window.NWFly.hwFor(it.handle); };
  /* opening a line's details is the moment before Edit design: fetch its front picture and the design then */
  root.addEventListener('pointerdown', e => { const c = e.target.closest('.nw-item'); const a = c && c.querySelector('[data-tag-edit]'); if (!a || !cart) return; const it = cart.items.find(x => x.key === a.dataset.tagEdit); if (it) warmEdit(it); }, true);
  function flyEdit(a, it) {
    if (innerWidth >= 768 || !window.NWFly || window.__nwFlyOn) return;
    const src = frontOf(it); if (!src) return;
    warmEdit(it);
    const x = frIm[src], pv = a.closest('.nw-item') && a.closest('.nw-item').querySelector('.nw-item__pv'), H = innerHeight;
    const pr = it.properties || {}, colour = String(pr.Color || pr.Colour || '');
    window.__nwFlyOn = true;
    /* the picture and the design's colours: a moment's wait at most (they were fetched when the line was opened) */
    Promise.race([Promise.all([new Promise(r => { if (x.complete) r(); else { x.addEventListener('load', r); x.addEventListener('error', r); } }), window.NWFly.design(it.handle)]), new Promise(r => setTimeout(r, 400))]).then(() => {
      window.__nwFlyOn = false;
      if (x.complete && !x.naturalWidth) return;   /* no picture: the personalizer opens as before */
      const ar = x.naturalWidth ? x.naturalWidth / x.naturalHeight : .8, d = window.NWFly.design(it.handle).v;
      const cols = d && (d.palettes || []).length ? d.palettes.map(p => ({ c: p.swatch, n: p.label, on: p.label.toLowerCase() === colour.toLowerCase() })) : null;
      let rect, rot = 0;
      const q = pv && pv.getBoundingClientRect();
      if (q && q.width && q.bottom > 0 && q.top < H) {
        /* the line's picture is the pair as on the product photos: the front tag centred at 38.5% across, from 39% down, 45% tall */
        const h = q.height * .45, w = h * ar; rect = { left: q.left + q.width * .385 - w / 2, top: q.top + q.height * .39, width: w, height: h }; rot = -8;
      } else { const b = a.getBoundingClientRect(), s = 48; rect = { left: b.left + b.width / 2 - s / 2 * ar, top: b.top + b.height / 2 - s / 2, width: s * ar, height: s }; }
      window.NWFly.flyIn(null, null, window.NWFly.hwFor(it.handle), { src, rect, rot, ar, cols, portrait: /portrait/.test(it.handle), edit: { name: pr.Name || '' },
        retry: () => { location.href = it.url + (it.url.indexOf('?') < 0 ? '?' : '&') + 'nwedit=' + encodeURIComponent(it.key); } });
    });
  }
  root.addEventListener('click', e => { const a = e.target.closest('[data-collar-edit]'); if (!a || !cart || !window.NWWardrobe || !window.NWWardrobe.editCartLine) return; const it = cart.items.find(x => x.key === a.dataset.collarEdit); if (it && window.NWWardrobe.editCartLine(it)) e.preventDefault(); });
  root.querySelector('[data-nw-cart-close]').addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && root.classList.contains('open')) closeCart(); });

  root.addEventListener('click', e => {
    const rm = e.target.closest('[data-rmcode]');
    if (rm) {
      /* removing the welcome code removes every copy of it (a test sign-up more than once leaves several) */
      const W = /^(NW10-|NWHELLO)/i, gone = rm.dataset.rmcode;
      const keep = (cart.discount_codes || []).map(d => d.code).filter(c => W.test(gone) ? !W.test(c) : c !== gone);
      post('cart/update.js', { discount: keep.join(',') });
      return;
    }
    const q = e.target.closest('[data-q]');
    if (q) {
      const ln = parseInt(q.dataset.q, 10), to = Math.max(0, parseInt(q.dataset.to, 10));
      /* a deleted line leaves only the cart: a saved design stays in the wardrobe */
      post('cart/change.js', { line: ln, quantity: to });
      return;
    }
    const a = e.target.closest('[data-add]');
    if (a) { if (a.dataset.key) added[a.dataset.key] = 1; post('cart/add.js', { items: [{ id: parseInt(a.dataset.add, 10), quantity: 1 }] }); return; }
    const x = e.target.closest('[data-xc]');
    if (x) { const k = x.dataset.xc; open[k] = !open[k]; const c = x.closest('.nw-item'); c.classList.toggle('open', open[k]); x.setAttribute('aria-expanded', String(open[k])); }
  });
  // collapsed note row: "Add a note to your order", or a one-line preview "Note: ..." once something is written
  function noteLabel(v) {
    v = String(v || '').replace(/\s+/g, ' ').trim();
    return v ? '<b>' + TX.note_label + '</b> ' + esc(v) : TX.add_note;
  }
  // tapping away from the note closes it and shows the preview (a tap on the row itself just toggles it as usual)
  let noteRowTap = false;
  root.addEventListener('pointerdown', e => { noteRowTap = !!e.target.closest('.nw-note summary'); }, true);
  root.addEventListener('focusout', e => {
    if (e.target.id !== 'nw-cart-note') return;
    const d = e.target.closest('.nw-note');
    d.querySelector('.nw-note__lbl').innerHTML = noteLabel(e.target.value);
    if (!noteRowTap) { d.open = false; noteOpen = false; }
    noteRowTap = false;
  });
  // remember whether the note is open (the typed text is kept in noteDraft)
  root.addEventListener('toggle', e => {
    if (!(e.target.classList && e.target.classList.contains('nw-note'))) return;
    noteOpen = e.target.open;
    if (e.target.open) {   // opened near the bottom of the list: slide it up into view once
      const r = e.target.getBoundingClientRect(), b = body.getBoundingClientRect();
      if (r.bottom > b.bottom - 8) body.scrollBy({ top: r.bottom - b.bottom + 16, behavior: 'smooth' });
    }
  }, true);
  let noteTimer;
  const saveNote = v => fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) });
  root.addEventListener('input', e => {
    if (e.target.id !== 'nw-cart-note') return;
    clearTimeout(noteTimer); const v = e.target.value; noteDraft = v;
    noteTimer = setTimeout(() => saveNote(v), 600);
  });
  // finish the note: the checkmark, or return ("done" on phones; Shift+Enter still makes a line break on a computer).
  // Saves right away, closes the row and shows the "Note: ..." preview.
  function finishNote() {
    const ta = root.querySelector('#nw-cart-note'); if (!ta) return;
    const d = ta.closest('.nw-note');
    clearTimeout(noteTimer); noteDraft = ta.value; saveNote(ta.value);
    d.querySelector('.nw-note__lbl').innerHTML = noteLabel(ta.value);
    d.open = false; noteOpen = false;
    if (document.activeElement === ta) ta.blur();
  }
  root.addEventListener('keydown', e => {
    if (e.target.id !== 'nw-cart-note' || e.key !== 'Enter' || e.shiftKey || e.isComposing) return;
    e.preventDefault(); finishNote();
  });
  root.addEventListener('click', e => { if (e.target.closest('[data-note-done]')) finishNote(); });
})();
